import typeCheck from 'common/util/typeCheck';

export default function setUpdateMoveInDateModalOpen({ state }, updateMoveInDateModalOpen) {
  typeCheck('updateMoveInDateModalOpen::Boolean', updateMoveInDateModalOpen);
  state.set(['updateMoveInDate', 'modalOpen'], updateMoveInDateModalOpen);
  state.commit();
}
